const formControlLabelCalendar = {
  checkActions: 'Actions',
  checkServices: 'Services done',
  checkFutureServices: 'Future Services',
  checkMaintenances: 'Maintenances',
  checkServicesReplicated: 'Services to be done/overdue',
};

export default formControlLabelCalendar;
